import {z} from '@hono/zod-openapi';

import {SipHeaderSchema} from './SipHeaderSchema';

export const IncomingVoiceCallWebhookSchema = z
  .object({
    id: z.string().min(1),
    type: z.literal('realtime.call.incoming'),
    created_at: z.number().int().nonnegative(),
    // Not `.strict()`. This is a beta vendor payload: OpenAI can add fields to the Realtime SIP
    // webhook at any time, and rejecting an unrecognized key would turn that into a 400 that blocks
    // every inbound call until the schema is updated. Plain object mode strips what we do not read.
    data: z.object({
      call_id: z.string().min(1),
      sip_headers: z.array(SipHeaderSchema),
    }),
    object: z.literal('event').optional(),
  })
  .openapi('IncomingVoiceCallWebhookSchema');
